import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { ChannelSourcesViewService } from '../../data/services/view/channel-sources-view.service'
import { IChannelSource } from '../../data/interfaces/channel-source.interface'

@Component({
  selector: 'app-channel-source-form',
  templateUrl: './channel-source-form.component.html',
  styleUrls: ['./channel-source-form.component.scss'],
})
export class ChannelSourceFormComponent implements OnChanges {
  @Input() visible = false
  @Input() editing: IChannelSource | null = null

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() saved = new EventEmitter<void>()

  form: FormGroup

  //* alineado al seed del PRD §6.2 — el admin puede dejar null o exigir un rol
  roleOptions = [
    { label: '— ninguno (auto-registro digital) —', value: null },
    { label: 'Operaciones (interno)', value: 'Operaciones' },
    { label: 'Broker', value: 'Broker' },
    { label: 'MasterBroker', value: 'MasterBroker' },
  ]

  //* agrupación para KPIs (no define ownership): external/internal/self
  categoryOptions = [
    { label: 'Interno (vendedor)', value: 'internal' },
    { label: 'Externo (broker / masterbroker)', value: 'external' },
    { label: 'Auto-registro (cliente)', value: 'self' },
  ]

  constructor(private fb: FormBuilder, private viewService: ChannelSourcesViewService) {
    this.form = this.fb.group({
      key: ['', [Validators.required, Validators.pattern(/^[a-z0-9_]+$/)]],
      label: ['', Validators.required],
      actorRoleRequired: [null],
      description: [''],
      category: ['internal', Validators.required],
      active: [true],
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editing']) {
      if (this.editing) {
        this.form.patchValue(this.editing)
        this.form.get('key')?.disable() //* key inmutable post-creación (PRD F1)
      } else {
        this.form.reset({ active: true, actorRoleRequired: null, category: 'internal' })
        this.form.get('key')?.enable()
      }
    }
  }

  submit(): void {
    if (this.form.invalid) return
    //* getRawValue incluye el control `key` (disabled). En UPDATE el `key` es INMUTABLE y el
    //* backend lo rechaza (whitelist) → se excluye. En CREATE va completo (incluye key + active).
    const value = this.form.getRawValue()
    const obs = this.editing ? this.viewService.update(this.editing._id, (({ key, ...rest }) => rest)(value)) : this.viewService.create(value)
    obs.subscribe((r) => {
      if (!r.error) {
        this.saved.emit()
        this.close()
      }
    })
  }

  close(): void {
    this.visible = false
    this.visibleChange.emit(false)
  }
}
